import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CampaignsComponent} from './campaigns.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '@shared/material/material.module';



@NgModule({
    declarations: [CampaignsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
    ],
    exports: [CampaignsComponent],
})
export class CampaignsModule { }
